import angular from 'angular';

let moduleName = 'app.filters';

angular.module(moduleName, [])
  .filter('messageDateTime', ['$filter', function ($filter) {
    return function (isoDateTime) {
      const regexIso8601FromBackend = /^\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d(([+\-]\d\d):00)$/;
      const match = isoDateTime.match(regexIso8601FromBackend);
      if (match) {
        const timezoneOffsetInt = Number(match[2]);
        const timezoneForDateFilter = match[1];
        return $filter('date')(isoDateTime, 'shortDate', timezoneForDateFilter)
          + ' ' + $filter('date')(isoDateTime, 'mediumTime', timezoneForDateFilter)
          + ' (GMT' + (timezoneOffsetInt >= 0 ? '+' : '') + timezoneOffsetInt + ')';
      }
      return isoDateTime;
    };
  }])
  /**
   * @deprecated
   * migrated in DateTimezonePipe in NG
   */
  .filter('dateTimezone', [
    '$filter',
    'UserFactory',
    'AngularTimezoneService',
    function ($filter, UserFactory, AngularTimezoneService) {
      return function (date, format) {
        if(!date) {
          return date;
        }

        // else is Date object
        if (typeof date === 'string') {
          if(date === 'N/A') {
            return date
          }

          // '2023-12-15T15:42:56'
          if (date.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/)) {
            date = `${date}Z`;
          }
          // '2023-12-15 15:42:56'
          else if (date.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
            date = `${date}Z`.replace(' ', 'T');
          }
        }

        const userTimezone = UserFactory.getLoggedUser().timezone;
        const timezoneOffset = AngularTimezoneService.formatOffsetForTimezone(date, userTimezone);
        return $filter('date')(date, format, timezoneOffset);
      };
    },
  ])
  .filter('trustedHtml', ['$sce', function ($sce) {
    return function (text) {
      return $sce.trustAsHtml(text);
    };
  }])
  /**
   * @deprecated
   * migrated in truncate-counter.pipe.ts
   */
  .filter('bulletCount', [function () {
    return function (number) {
      if (number > 1000000) {
        return `${Math.floor(number / 1000000)}M`;
      }
      if (number > 1000) {
        return `${Math.floor(number / 1000)}k`;
      }
      return number;
    };
  }])
  .filter('toArray', function () {
    return function (obj) {
      if (!angular.isObject(obj)) {
        return obj;
      }
      return Object.keys(obj).map((key) => obj[key]);
    };
  })
  ;


export default moduleName;
